import { render, staticRenderFns } from "./Failure.vue?vue&type=template&id=16a87624&scoped=true&"
import script from "./Failure.vue?vue&type=script&lang=js&"
export * from "./Failure.vue?vue&type=script&lang=js&"
import style0 from "./Failure.vue?vue&type=style&index=0&id=16a87624&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "16a87624",
  null
  
)

export default component.exports